import { api } from 'api'
import { path } from 'ramda'
import { TimelineShift } from 'api/shift'

export async function getReviewEvaluateShifts() {
  const data = await api.post(
    '/company/graphql_dispatch/shifts_to_review_needs_attention_141ba64d',
    {}
  )

  return path(
    ['data', 'data', 'company', 'performanceReviewShifts'],
    data
  ) as TimelineShift[]
}
